import { useCallback } from 'react';

import { EApiRoutes, getApiRouteOrMock } from '../api/api.utils';
import { EEventsType, ELocalStorageKeys } from '../constants/enums';
import { localStorageUtil } from '../utils/localStorageUtil';

import useAxios from './useAxios';

export interface BigQueryEventData {
  eventName: EEventsType;
  publisherId?: string;
  userId?: string;
  userEmail?: string;
  countryCode?: string;
  annualRev?: string;
  teamSize?: string;
  websiteUrl?: string;
  isCheckboxApproved?: boolean;
  phone?: string;
  taskName?: string;
  taskStatus?: string;
  method?: string;
  templateId?: string;
  isActiveTemplate?: boolean;
  templateAction?: string;
}

export const useBigQueryEventsTracking = () => {
  const axios = useAxios();

  const trackBigQueryEvent = useCallback(
    async (eventData: BigQueryEventData) => {
      try {
        if (!eventData.eventName) {
          console.warn('Event name is required for BigQuery tracking');
          return;
        }

        const userDetails = localStorageUtil.getAny(
          ELocalStorageKeys.USER_DETAILS
        );
        const publisherIdFromStorage = localStorageUtil.getAny<string>(
          ELocalStorageKeys.PUBLISHER_ID
        );

        const userId = eventData.userId || userDetails?.userId;
        const publisherId = eventData.publisherId || publisherIdFromStorage;
        const userEmail = eventData.userEmail || userDetails?.email;

        const payload = {
          ...(publisherId && { publisherId }),
          eventName: eventData.eventName,
          ...(userId && { userId }),
          ...(userEmail && { userEmail }),
          ...(eventData.countryCode && { countryCode: eventData.countryCode }),
          ...(eventData.annualRev && { annualRev: eventData.annualRev }),
          ...(eventData.teamSize && { teamSize: eventData.teamSize }),
          ...(eventData.websiteUrl && { websiteUrl: eventData.websiteUrl }),
          ...(eventData.isCheckboxApproved !== undefined && {
            isCheckboxApproved: eventData.isCheckboxApproved
          }),
          ...(eventData.phone && { phone: eventData.phone }),
          ...(eventData.taskName && { taskName: eventData.taskName }),
          ...(eventData.taskStatus && { taskStatus: eventData.taskStatus }),
          ...(eventData.method && { method: eventData.method }),
          ...(eventData.templateId && { templateId: eventData.templateId }),
          ...(eventData.templateAction && {
            templateAction: eventData.templateAction
          }),
          ...(eventData.isActiveTemplate && {
            isActiveTemplate: eventData.isActiveTemplate
          })
        };

        await axios.post(
          getApiRouteOrMock(EApiRoutes.PUBLISHER_DASHBOARD_ACTIVITIES),
          payload
        );
      } catch (error) {
        console.error('Failed to send BigQuery event:', error);
      }
    },
    []
  );

  return {
    trackBigQueryEvent
  };
};
